var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush, getSupporterID } from "../shared/utils";
var dataToDataLayer = function (specificEventData) {
    // const eventData = Object.assign({}, (e?.detail));
    var dlData = normalizeObject(__assign({ event_category: "ecommerce" }, specificEventData));
    dataLayerPush(dlData);
};
var streamlinedAddToCart = function (e) {
    dataToDataLayer(__assign(__assign({ checkout_type: (e === null || e === void 0 ? void 0 : e.detail["checkout_type"]) ? e === null || e === void 0 ? void 0 : e.detail["checkout_type"] : "streamline_checkout", event: "add_to_cart", event_action: "add_to_cart", non_interaction: true, event_label: e === null || e === void 0 ? void 0 : e.detail["item_name"], ecommerce: {
            currency: "USD",
            value: e === null || e === void 0 ? void 0 : e.detail["cartTotal"],
            items: e === null || e === void 0 ? void 0 : e.detail["cartProducts"]
        }, hi_add_to_carts: 1, high_intent_interactions: 1 }, ((e === null || e === void 0 ? void 0 : e.detail["keyword"]) ? { "keyword": e === null || e === void 0 ? void 0 : e.detail["keyword"] } : {})), ((e === null || e === void 0 ? void 0 : e.detail["cobrand"]) ? { "cobrand": e === null || e === void 0 ? void 0 : e.detail["cobrand"] } : {})));
};
var streamlinedRemoveToCart = function (e) {
    dataToDataLayer(__assign(__assign({ event: "remove_from_cart", event_action: "remove_from_cart", non_interaction: true, event_label: e === null || e === void 0 ? void 0 : e.detail["item_name"], ecommerce: {
            currency: "USD",
            value: e === null || e === void 0 ? void 0 : e.detail["cartTotal"],
            items: e === null || e === void 0 ? void 0 : e.detail["cartProducts"]
        }, hi_add_to_carts: 1, high_intent_interactions: 1 }, ((e === null || e === void 0 ? void 0 : e.detail["keyword"]) ? { "keyword": e === null || e === void 0 ? void 0 : e.detail["keyword"] } : {})), ((e === null || e === void 0 ? void 0 : e.detail["cobrand"]) ? { "cobrand": e === null || e === void 0 ? void 0 : e.detail["cobrand"] } : {})));
};
var streamlinedBeginCheckout = function (e) {
    dataToDataLayer({
        checkout_type: (e === null || e === void 0 ? void 0 : e.detail["checkout_type"]) ? e === null || e === void 0 ? void 0 : e.detail["checkout_type"] : "streamline_checkout",
        event: "begin_checkout",
        event_action: "begin_checkout",
        event_label: e === null || e === void 0 ? void 0 : e.detail["event_label"],
        non_interaction: true,
        ecommerce: {
            currency: "USD",
            value: e === null || e === void 0 ? void 0 : e.detail["cartTotal"],
            items: e === null || e === void 0 ? void 0 : e.detail["cartProducts"]
        },
        hi_checkout_start: 1,
        high_intent_interactions: 1,
        keyword: e === null || e === void 0 ? void 0 : e.detail["keyword"],
        cobrand: e === null || e === void 0 ? void 0 : e.detail["cobrand"],
        step_number: 1,
    });
};
var streamlinedCheckoutViewItem = function (e) {
    dataToDataLayer({
        checkout_type: (e === null || e === void 0 ? void 0 : e.detail["checkout_type"]) ? e === null || e === void 0 ? void 0 : e.detail["checkout_type"] : "streamline_checkout",
        event: "view_item",
        event_action: "product_detail_view",
        event_label: e === null || e === void 0 ? void 0 : e.detail["event_label"],
        non_interaction: true,
        standard_interactions: 1,
        std_pdp_view: 1,
        ecommerce: {
            items: e === null || e === void 0 ? void 0 : e.detail["viewProducts"]
        },
        keyword: (e === null || e === void 0 ? void 0 : e.detail["keyword"]) || "",
        cobrand: (e === null || e === void 0 ? void 0 : e.detail["cobrand"]) || "",
    });
};
var streamlinedCheckoutError = function (e) {
    dataToDataLayer({
        event: "error_view",
        event_action: (e === null || e === void 0 ? void 0 : e.detail["event_action"]) || "",
        error_message: (e === null || e === void 0 ? void 0 : e.detail["error_message"]) || "",
        event_label: (e === null || e === void 0 ? void 0 : e.detail["event_label"]) || "",
        error_type: "chosen_photo",
        event_category: "chosen_error",
        keyword: (e === null || e === void 0 ? void 0 : e.detail["keyword"]) || "",
        cobrand: (e === null || e === void 0 ? void 0 : e.detail["cobrand"]) || "",
        event_errors: 1,
        total_errors: 1,
        non_interaction: true
    });
};
var streamlinedBeginCheckoutAltPay = function (e) {
    dataToDataLayer({
        checkout_type: "ecomm_express_payment",
        event: "streamline_paypal_express",
        event_action: "express_payment_method_click",
        event_category: "ecommerce",
        event_label: e === null || e === void 0 ? void 0 : e.detail["event_label"],
        non_interaction: true,
        ecommerce: {
            currency: "USD",
            value: e === null || e === void 0 ? void 0 : e.detail["cartTotal"],
            items: e === null || e === void 0 ? void 0 : e.detail["cartProducts"]
        },
        keyword: e === null || e === void 0 ? void 0 : e.detail["keyword"],
        cobrand: e === null || e === void 0 ? void 0 : e.detail["cobrand"],
        goal_reference: e === null || e === void 0 ? void 0 : e.detail["goalReference"],
    });
};
var streamlinedAltPayView = function (e) {
    dataToDataLayer(__assign(__assign(__assign({ checkout_type: (e === null || e === void 0 ? void 0 : e.detail["checkout_type"]) ? e === null || e === void 0 ? void 0 : e.detail["checkout_type"] : "streamline_checkout", event: "express_payment_method_view", event_action: "express_payment_method_view", event_label: e === null || e === void 0 ? void 0 : e.detail["event_label"], event_category: "payment_method", non_interaction: true, ecommerce: {
            currency: "USD",
            value: e === null || e === void 0 ? void 0 : e.detail["cartTotal"],
            items: e === null || e === void 0 ? void 0 : e.detail["cartProducts"]
        }, hi_checkout_start: 1, high_intent_interactions: 1 }, ((e === null || e === void 0 ? void 0 : e.detail["keyword"]) ? { "keyword": e === null || e === void 0 ? void 0 : e.detail["keyword"] } : {})), ((e === null || e === void 0 ? void 0 : e.detail["cobrand"]) ? { "cobrand": e === null || e === void 0 ? void 0 : e.detail["cobrand"] } : {})), { step_number: 1 }));
};
var streamlinedAddBillingAddress = function (e) {
    dataToDataLayer(__assign(__assign(__assign({ checkout_type: (e === null || e === void 0 ? void 0 : e.detail["checkout_type"]) ? e === null || e === void 0 ? void 0 : e.detail["checkout_type"] : "streamline_checkout", event: "add_billing_address", event_action: "billing_address", event_label: e === null || e === void 0 ? void 0 : e.detail["event_label"], non_interaction: true, ecommerce: {
            currency: "USD",
            value: e === null || e === void 0 ? void 0 : e.detail["cartTotal"],
            items: e === null || e === void 0 ? void 0 : e.detail["cartProducts"]
        } }, ((e === null || e === void 0 ? void 0 : e.detail["keyword"]) ? { "keyword": e === null || e === void 0 ? void 0 : e.detail["keyword"] } : {})), ((e === null || e === void 0 ? void 0 : e.detail["cobrand"]) ? { "cobrand": e === null || e === void 0 ? void 0 : e.detail["cobrand"] } : {})), { step_number: 2 }));
};
var streamlinedAddPaymentInfo = function (e) {
    dataToDataLayer(__assign(__assign(__assign({ checkout_type: (e === null || e === void 0 ? void 0 : e.detail["checkout_type"]) ? e === null || e === void 0 ? void 0 : e.detail["checkout_type"] : "streamline_checkout", event: "add_payment_info", event_action: "payment_method", event_label: e === null || e === void 0 ? void 0 : e.detail["event_label"], ecommerce: {
            currency: "USD",
            value: e === null || e === void 0 ? void 0 : e.detail["cartTotal"],
            items: e === null || e === void 0 ? void 0 : e.detail["cartProducts"]
        }, non_interaction: true }, ((e === null || e === void 0 ? void 0 : e.detail["keyword"]) ? { "keyword": e === null || e === void 0 ? void 0 : e.detail["keyword"] } : {})), ((e === null || e === void 0 ? void 0 : e.detail["cobrand"]) ? { "cobrand": e === null || e === void 0 ? void 0 : e.detail["cobrand"] } : {})), { step_number: 3 }));
};
var streamlinedPhotoUpload = function (e) {
    dataToDataLayer({
        event_action: "photo_upload",
        non_interaction: true,
    });
};
var streamlinedPhotoModeration = function (e) {
    dataToDataLayer({
        event_action: "photo_moderation",
        non_interaction: true,
    });
};
var streamlinedPhotoRetake = function (e) {
    dataToDataLayer({
        event_action: "photo_retake",
        non_interaction: true,
    });
};
var streamlinedThankYouView = function (e) {
    dataToDataLayer({
        event_action: "thank_you_view",
        non_interaction: true,
    });
};
var streamlinedPurchase = function (e) {
    var wooOrderId = e === null || e === void 0 ? void 0 : e.detail["wc_order_id"];
    var orderRef = (e === null || e === void 0 ? void 0 : e.detail["order_ref"]) || "prod";
    var env = (e === null || e === void 0 ? void 0 : e.detail["env"]) || "prod";
    var transactionId = "wvus-woo-".concat(env, "-").concat(wooOrderId);
    var supporter_id = getSupporterID();
    dataToDataLayer(__assign(__assign({ checkout_type: (e === null || e === void 0 ? void 0 : e.detail["checkout_type"]) ? e === null || e === void 0 ? void 0 : e.detail["checkout_type"] : "streamline_checkout", event: "purchase", event_action: "purchase", event_category: "ecommerce", event_label: e === null || e === void 0 ? void 0 : e.detail["event_label"], ecommerce: {
            currency: "USD",
            value: e === null || e === void 0 ? void 0 : e.detail["cartTotal"],
            items: e === null || e === void 0 ? void 0 : e.detail["cartProducts"],
            transaction_id: transactionId
        }, non_interaction: true, campaign_code: e === null || e === void 0 ? void 0 : e.detail["campaign_code"], cover_fee_amount: "", cover_fee_selected: "no_cover_the_fee", payment_method_option: (e === null || e === void 0 ? void 0 : e.detail["payment_method_option"]) || "", site_transaction_id: transactionId, site_transaction_status: "pending", supporter_id: supporter_id }, ((e === null || e === void 0 ? void 0 : e.detail["keyword"]) ? { "keyword": e === null || e === void 0 ? void 0 : e.detail["keyword"] } : {})), ((e === null || e === void 0 ? void 0 : e.detail["cobrand"]) ? { "cobrand": e === null || e === void 0 ? void 0 : e.detail["cobrand"] } : {})));
};
export { streamlinedAddToCart, streamlinedRemoveToCart, streamlinedBeginCheckout, streamlinedCheckoutViewItem, streamlinedBeginCheckoutAltPay, streamlinedAltPayView, streamlinedAddBillingAddress, streamlinedAddPaymentInfo, streamlinedPhotoUpload, streamlinedPhotoModeration, streamlinedPhotoRetake, streamlinedThankYouView, streamlinedPurchase, streamlinedCheckoutError };
